export default String.raw`
.comparison {
    &__dialog {
        .dialog {
            &__content {
                padding: 24px 16px 0 16px;
                gap: 24px;
            }
            &__header {
                flex-direction: column-reverse;
                align-items: flex-start;

                &-wrapper {
                    > svg {
                        display: none;
                    }
                }
                .comparison__items {
                    margin-left: 0;
                }

                form {
                    position: absolute;
                    top: 16px;
                    right: 16px;
                }
            }
        
            &__title {
                @include h4-headline;
            }
        
            &__actions {
                justify-content: center;
                flex-direction: column-reverse;
                align-items: center;
                padding: 24px 16px;
                gap: 16px;
            }
        }
    }
}

`